"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Preview = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var Form_1 = require("../../../Form");
var ExtendedPreview_1 = require("./ExtendedPreview");
var FormattedPreview_1 = require("../shared/FormattedPreview");
var DEFAULT_PREVIEW_VALUE = -1234.5678;
var Preview = /** @class */ (function (_super) {
    tslib_1.__extends(Preview, _super);
    function Preview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            preview: DEFAULT_PREVIEW_VALUE,
        };
        _this.onPreviewChange = function (value) {
            _this.setState({ preview: value });
        };
        return _this;
    }
    Preview.prototype.render = function () {
        var _a = this.props, format = _a.format, separators = _a.separators, intl = _a.intl;
        return (react_1.default.createElement("div", { className: "gd-measure-custom-format-dialog-section gd-measure-custom-format-dialog-section-preview" },
            react_1.default.createElement("span", { className: "gd-measure-custom-format-dialog-section-title" }, intl.formatMessage({ id: "measureNumberCustomFormatDialog.preview" })),
            react_1.default.createElement("div", { className: "gd-measure-custom-format-dialog-preview" },
                react_1.default.createElement(Form_1.InputWithNumberFormat, { className: "s-custom-format-dialog-preview-input gd-measure-custom-format-dialog-preview-input", value: this.state.preview, isSmall: true, autofocus: false, onChange: this.onPreviewChange, separators: separators }),
                react_1.default.createElement(FormattedPreview_1.FormattedPreview, { previewNumber: this.state.preview, format: format, separators: separators, className: "s-custom-format-dialog-preview-formatted gd-measure-custom-format-dialog-preview-string" })),
            react_1.default.createElement(ExtendedPreview_1.ExtendedPreview, { format: format, separators: separators })));
    };
    return Preview;
}(react_1.default.PureComponent));
exports.Preview = Preview;
exports.default = react_intl_1.injectIntl(Preview);
//# sourceMappingURL=Preview.js.map